module.exports = __webpack_public_path__ + "static/media/preview.33e7ff2d.svg";